import React, { useRef, useState } from "react";
import Modal from "../../ReusableComponents/Modal";
import { BES_INCENTIVE_STATUS, RESCHEDULED_REASONS } from "../../appConstants";
import Calender from "react-calendar";
import Button from "../RequestsOverView/Button";
import attachmentIcon from "../../assets/attachmentIcon.svg";
import { updateIncentive, updateIncentiveStatus } from "../../apis/incentives/incentives";
import Popup from "../../ReusableFunctions/Popup";
import Loading from "../../ReusableFunctions/Loader";

export default function MakePaymentPopup({
  open,
  onClose,
  incentive,
  onRequestUpdate,
}) {
  const [error, setError] = useState();
  const [file, setFile] = useState(null);
  const [paymentMode, setPaymentMode] = useState("Cash");
  const [fileName, setFileName] = useState("");


  const fileInputRef = useRef(null);

  const handleDivClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    if (e.target.files.length > 0) {
      setFile(e.target.files[0])
      setFileName(e.target.files[0].name);
    }
  };


  const resetForm = () => {
    setFileName(null)
    setFile(null);
  }

  return (
    <Modal
      header={"Make Payment"}
      open={open}
      onClose={onClose}
      contentStyle={{ width: "580px", height: "auto" }}
      divider={true}
      headerContainerStyle={{ padding: "15px 30px" }}
      headingStyle={{ fontSize: "16px", fontWeight: 600 }}
      iconSize={"18px"}
    >
      <div className="flex flex-col justify-between">
        <div className="flex flex-col w-full gap-6 py-4 px-8">
          {/* Select payment mode */}
          <div className="flex flex-col gap-2 ">
            <label className="text-[#3B3B3B]">Select payment mode </label>
            <div className="flex gap-8 mt-2 items-center">
              {[{ label: "Cash", value: "Cash" }, { label: "UPI", value: "Upi" }].map(
                (option) => (
                  <div
                    className="flex gap-3 text-[16px] font-manrope"
                    key={option.value}
                  >
                    <input
                      className="cursor-pointer focus:outline-none"
                      type="radio"
                      name="options"
                      value={option.value}
                      checked={paymentMode === option.value}
                      onChange={(e) => {
                        setPaymentMode(e.target.value);
                      }}
                    />
                    <label>{option.label}</label>
                  </div>
                )
              )}
            </div>
          </div>

          {/* Payment Details */}
          <div className="w-[400px] mt-2 border rounded-[10px] border-[#3B3B3B]/30">
            <p className="px-4 py-1 pt-2">Cash Payment</p>
            <div className="h-[5px] border-b border-b-[#BFC8D9]"></div>
            <div className="px-5 pt-4 py-5 flex flex-col gap-1">
              <div className="flex justify-between items-center">
                <p className="text-[#3B3B3B] text-[14px]">Amount </p>
                <span className="text-[#3B3B3B] text-[14px]">
                  {incentive?.incentive_amount
                    ? `₹ ${incentive?.incentive_amount}`
                    : "-"}
                </span>
              </div>
              <div className="flex mt-2 justify-between items-center">
                <p className="text-[#3B3B3B] text-[14px]">BES </p>
                <span className="text-[#3B3B3B] text-[14px]">
                  {incentive?.bes_name || "-"}
                </span>
              </div>
              <div className="flex mt-2 justify-between items-center">
                <p className="text-[#3B3B3B] text-[14px]">Contact No. </p>
                <span className="text-[#3B3B3B] text-[14px]">
                  {incentive?.bes_phone ? `${incentive?.bes_phone}` : "-"}
                </span>
              </div>
              {paymentMode === "Upi" && (
                <div className="flex mt-2 justify-between items-center">
                  <p className="text-[#3B3B3B] text-[14px]">UPI ID</p>
                  <span className="text-[#3B3B3B] text-[14px]">
                    {incentive?.bes_upi ? `${incentive?.bes_upi}` : null}
                  </span>
                </div>
              )}
            </div>
          </div>

          {/* Note */}
          {paymentMode === "Upi" && (
            <>
              <div className="mt-4 rounded-[8px] text-[13px] font-manrope border border-[#E96E31] px-3 py-[3px] bg-[#E96E31]/10 w-fit">
                <span className="font-manrope text-[#E96E31] font-[550]">
                  Please make payment on above UPI ID and attach screenshot.
                </span>
              </div>

              <div className="flex flex-col gap-2">
                <label className="font-manrope font-[400] text-[#3B3B3B] text-[15px]">
                  Attach payment screenshot
                </label>
                <div
                  onClick={handleDivClick}
                  className="w-[400px] bg-[#F3F3F3] h-[40px] py-1 px-3 flex gap-2 items-center border border-[#BFC8D9] rounded-md cursor-pointer"
                >
                  <img
                    src={attachmentIcon}
                    alt="attachment icon"
                    width={15}
                    height={15}
                  />
                  <span className="text-[13px] font-manrope font-[400] text-[#3B3B3B]">
                    {fileName || "Upload payment screenshot"}
                  </span>
                </div>
                {/* Hidden file input */}
                <input
                  type="file"
                  accept="image/*"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  className="hidden"
                />
              </div>
            </>
          )}
        </div>

        {/* Footer buttons */}
        <div className="flex ml-auto px-8 py-4 gap-6">
          <Button
            color={"#606571"}
            variant={"outlined"}
            title={"Cancel"}
            handleClick={onClose}
          />
          <Button
            color={"#0F5EFF"}
            isDisbaled={(paymentMode === "Upi" && !fileName)}
            variant={"filled"}
            title={"Payment Done"}
            hoverColor={"#1251D2"}
            handleClick={async () => {
              try {
                Loading.set(true);
                const formData = new FormData();
                formData.append('payment_proof', file);
                formData.append('payment_mode', paymentMode);
                formData.append('status', BES_INCENTIVE_STATUS.SUBMITTED)
                const { updatedIncentive } = await updateIncentive(incentive.id, formData);

                Popup.alert(paymentMode === "Cash" ? "Order Marked as Paid!" : "Payment details updated!",
                  paymentMode === "Cash" ? `Cash payment completed. Order marked as paid.` : "Your payment details have been submitted.",
                  "SUCCESS")
                resetForm();
                onClose()
                onRequestUpdate(updatedIncentive);
              } catch (err) {
                Loading.set(false);
                console.log("err", err);
                Popup.alert(
                  "ERROR",
                  err || "Something went wrong while rescheduling request",
                  "ERROR"
                );
              } finally {
                Loading.set(false);
              }
            }}
          />
        </div>
      </div>
    </Modal>
  );
}
